import React from "react";

import { CommonTypes } from "@assets/types";
import { classNames } from "@assets/utilities/classNameUtilities";

import MenuLink, { MenuLinkProps } from "./MenuLink";

interface MenuProps {
  /** The Menu item children. */
  children: React.ReactNode;
  /*Extend the menu list styles. */
  className?: string;
  /** If true, the menu items are shown. */
  isOpen?: boolean;
  onMouseOut?: CommonTypes.CallbackFunction;
  onMouseOver?: CommonTypes.CallbackFunction;
}

interface ItemProps extends MenuLinkProps {
  /** The menu item title/ element. */
  children: React.ReactNode;
  /** Extend the menu item styles. */
  className?: string;
  /** To have a bottom border or not. */
  lined?: boolean;
  /** The differetne sizes of the menu items. */
  size?: "small" | "medium" | "none";
  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   */
  onClick?: React.MouseEventHandler;
}

const Menu: React.FC<MenuProps> & {
  Item: React.ElementType;
} = ({
  children,
  className,
  isOpen = false,
  onMouseOut,
  onMouseOver,
}: MenuProps) => {
  return (
    <ul
      className={classNames(
        "absolute z-10 bg-neutral-0 w-max py-1 border rounded transition",
        !isOpen && "hidden",
        className
      )}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
    >
      {children}
    </ul>
  );
};

const sizes = {
  small: "px-5 py-1",
  medium: "px-4 h-10",
  none: "",
};

const Item = ({
  children,
  className,
  href,
  lined = false,
  size = "medium",
  onClick,
  ...rest
}: ItemProps) => {
  const liItemClassNames = classNames(
    "flex items-center hover:bg-neutral-300 cursor-pointer",
    sizes[size],
    lined && "border-b last:border-none"
  );
  return (
    <li className={liItemClassNames}>
      <MenuLink
        className={className}
        href={href}
        noUnderline
        onClick={onClick}
        {...rest}
      >
        {children}
      </MenuLink>
    </li>
  );
};

Menu.Item = Item;

export default Menu;
